import React, { Component } from 'react';
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";
import { highlightedLivestreamData } from './HighlightedLivestreamData';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';

class HighlightedLivestream extends Component {
  constructor(props) {
    super(props);
    this.slideLeft = this.slideLeft.bind(this);
    this.slideRight = this.slideRight.bind(this);
  }


  slideLeft() {
    var slider = document.getElementById('sliderHighlight')
    slider.scrollLeft = slider.scrollLeft - document.documentElement.clientWidth * .955
  }

  slideRight() {
    var slider = document.getElementById('sliderHighlight')
    slider.scrollLeft = slider.scrollLeft + document.documentElement.clientWidth * .955
  }

  render() {

    return (
      <div>
        <div className="mt-16 relative flex items-center">
        <MdChevronLeft className="opacity-50 cursor-pointer hover:opacity-100 text-white" onClick={this.slideLeft} size={40} />
          <div id="sliderHighlight" className="w-full h-full overflow-x-scroll scroll whitespace-nowrap scroll-smooth scrollbar-hide">
          {highlightedLivestreamData.map((item) => (
            <div className="inline-block">
            <video
              onClick={()=> {
                loggingUtils.logEvent(
                  this.props.address != null
                    ? this.props.address
                    : encryptUtils.getWalletUnconnectedUserId(),
                  "home",
                  "home_click_next_livestream",
                  "info",
                  "https://the402.xyz",
                  {}
                );
                window.open(window.location.origin + item.itemRoute, "_self")
              }}
              className="h-144 dark:opacity-40 inline-block w-screen object-cover cursor-pointer bg-black shadow-[0_4px_20px_rgba(0,0,0,0.4)]"
              src={item.video}
              loop autoplay="autoplay" controls muted
            >
            </video>
            <div className="relative flex justify-start bottom-[290px] left-10">
              <div className="text-8xl font-bold text-white ">
                {item.creatorName}
              </div>
            </div>
            </div>
          ))}
          </div>
        <MdChevronRight className="opacity-50 cursor-pointer hover:opacity-100 text-white" onClick={this.slideRight} size={40} />
        </div>
      </div>
    );
  }
}

export default HighlightedLivestream;
